
export const defaultMenu = [
  { name: "Home", path: "/" },
  { name: "Courses", path: "/courses" },
  { name: "Projects", path: "/projects" },
  { name: "Research", path: "/research_assistance" },
  { name: "Publications", path: "/publications" },
  { name: "Careers", path: "/careers" },
  { name: "Gallery", path: "/gallery" },
  { name: "Contact Us", path: "/contact_us" },
];
